import { css } from "@emotion/react";

export const pageSectionCss = css`
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
`;

export const filtersContainerCss = css`
  flex-wrap: wrap;
  display: flex;
  gap: 20px;
`;

export const searchContainerCss = css`
  margin-top: 23px;
`;

export const upperPaginationCss = css`
  margin: 40px 0 20px;
`;
